/*global $, JQuery, alert, console*/
$(function () {
    'use strict';

    const dir = $('html').attr('dir');

    if ($('.search-results-body-screen').length > 0) {
        $.validator.addMethod("englishRegex", function (value, element) {
            return this.optional(element) || /^[a-zA-Z\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]*$/
            .test(value);
        });
        $.validator.addMethod("arabicRegex", function (value, element) {
            return this.optional(element) || /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g
            .test(value);
        });
        const messagesError = {
            search: {
                required: {
                    en: 'Please fill this field',
                    ar: 'يرجى ملء هذا الحقل',
                }
            }
        }
        $('form.search-input').validate({
            rules: {
                search: {
                    englishRegex: dir == 'ltr'? true : false,
                    arabicRegex: dir == 'rtl'? true : false,
                }
            },
            messages: {
                search: {
                    required: dir == 'ltr'? messagesError.search.required.en : messagesError.search.required.ar,
                    englishRegex: 'Please enter English characters only',
                    arabicRegex: 'الرجاء إدخال الحروف العربية فقط'
                }
            },
            errorElement: 'em',
            submitHandler: function(e) {
                console.log('submitted!');
            },
        })
    }

    // accessibilty improvements
    $('.faq-body-screen .search-input > label.visually-hidden').remove();
    $('.faq-body-screen .label-col > label').attr('for', 'finderInput');

    $('.appointment-page-body-screen #reason_input').parent().append(`
        <label for="reason_input" class="visually-hidden">${dir=='ltr'?'Reason for booking': 'سبب الحجز'}</label>`);
    
    setTimeout(() => {
        $('.g-recaptcha-response').parent().append(`
            <label for="g-recaptcha-response-100000" class="visually-hidden">recaptcha field</label>`);
    }, 500);

    $('.circulars-body-screen .search-input > label').text(`${dir=='ltr'?'Search':'بحث'}`);

    $('.training-body-screen .attachment-student > h3').remove();
    $('.training-body-screen fieldset#edu-field').append(`
        <label for="other-university" class="visually-hidden">${dir=='ltr'?'Other University': 'جامعات أخرى'}</label>`);

    if ($('.activities-body-screen').length > 0 && $('.title-and-breadcrumb .header-title').text() == '') {
        if (dir == 'ltr') {
            $('.title-and-breadcrumb .header-title').text('Events');
        } else {
            $('.title-and-breadcrumb .header-title').text('الأحداث');
        }
    }
    // accessibilty improvements

    // Start Banner Carousel
    if ($('#gta-carousel').length > 0) {
        const morphToPause = document.getElementById('morphToPause');
        const morphToPlay = document.getElementById('morphToPlay');
        const morphToPause2 = document.getElementById('morphToPause2');
        const morphToPlay2 = document.getElementById('morphToPlay2');
        const bCarousel = document.querySelector('#gta-carousel');
        const nCarousel = document.querySelector('#breakingNews');

        let paused = false;
        const bannerCarousel = new bootstrap.Carousel(bCarousel, {
            interval: 5000,
            pause: false
        });

        let newsPaused = false
        const newsCarousel = new bootstrap.Carousel(nCarousel, {
            interval: 5000,
            pause: false
        });

        $('#toggleCarousel').click(function() {
            if (paused) {
                paused = !paused;
                bannerCarousel.cycle();
                morphToPause.beginElement();
            } else {
                paused = !paused;
                bannerCarousel.pause();
                morphToPlay.beginElement();
            }
        });

        $('#toggleNews').click(function() {
            if (newsPaused) {
                newsPaused = !newsPaused;
                newsCarousel.cycle();
                morphToPause2.beginElement();
            } else {
                newsPaused = !newsPaused;
                newsCarousel.pause();
                morphToPlay2.beginElement();
            }
        });
    }
    // End Banner Carousel    

    if ($('.appointment-cancel-body-screen').length > 0) {
        if (window.location.pathname === "/en/form-result/success" || window.location.pathname === "/ar/form-result/success") {
            let urlParams = new URLSearchParams(window.location.search);
            let id = urlParams.get('id');
            let appointmentIdText = '';

            if (dir === 'ltr')  appointmentIdText = `Reference Number: ${id}`
            if (dir === 'rtl') appointmentIdText = `الرقم المرجعي: ${id}`
            
            setTimeout(() => {
                $('.appointment-cancel-body-screen #appointmentID').text(appointmentIdText);
            }, 200);
        }
    }

    $("input[name='name'], input[name='responsible-name']").on("input",function(event) {
        var inputValue = $(this).val();
        $(this).val(inputValue.replace(/[^a-zA-Z\u0621-\u064A ]/g,""));
    });

    $("#trainingForm input[name='personal-id-nmber'], .apply-job-form input[name='personal-id-nmber']").on("input",function(event) {
        var inputValue = $(this).val();
        $(this).val(inputValue.replace(/[^0-9]/g,""));
    });

    $(document).on('keyup', '.phone-numbers', function () {
        var engNumbers = $(this).val();
        $(this).attr('data-number', engNumbers);
    });
    // phone number input to arabic

    $('.phone-numbers').on('input', function (e) { //  Allow only numbers
        var inputValue = $(this).val();
        $(this).val(inputValue.replace(/[^\d\u0660-\u0669\u06F0-\u06F9]/g, ''));
    });

    // display or hide 3rd attachment upload based on radio
    $('.main-training-content .att-student-radio .form-check-input').on('change', ()=> {
        let checkedVal = $('.main-training-content .att-student-radio .form-check-input:checked').val();
        if (checkedVal.toLowerCase() === 'yes') {
            $('.main-training-content .attachment-student').show();
        } else {
            $('.main-training-content .attachment-student').hide();
        }
    })
    // display or hide 3rd attachment upload based on radio

    $(document).on('change', '.main-training-content .uni-school-radio .form-check-input', function() {
        let checkedVal = $('.main-training-content .uni-school-radio .form-check-input:checked').val();
        if (checkedVal.toLowerCase() === 'university') {
            $('.main-training-content .school-group').hide();
            $('.main-training-content .uni-drop').show();
        } else {
            $('.main-training-content .uni-drop').hide();
            $('.main-training-content .school-group').show();
        }
    })

    $('.main-training-content .uni-drop .form-select').on('change', function() {
        let val = $(this).val();
        if (val.toLowerCase() == 'other') {
            $('.main-training-content .uni-drop input').show();
        } else {
            $('.main-training-content .uni-drop input').hide();
        }
    })

    $('.appointment-form #reason-for-booking').on('change', function() {
        var val = $(this).val();
        if (val.toLowerCase() == 'other-provide-a-reason' || val.toLowerCase() == 'other') {
            $(this).addClass('hidden');
            $('.appointment-form #reason_input').removeClass('hidden');
            if (dir == 'ltr') {
                $('.appointment-form #reason_input').parent().css('position', 'relative').append('<div class="reset-view">choose again</div>');
            } else {
                $('.appointment-form #reason_input').parent().css('position', 'relative').append('<div class="reset-view">اختر مرة أخرى</div>');
            }
        }
    })
    $('body').on('click', '.appointment-form .reset-view', function () {
        $('.appointment-form #reason-for-booking').val('')
        $('.appointment-form #reason-for-booking').removeClass('hidden');
        $('.appointment-form #reason_input').addClass('hidden');
        $('.appointment-form .reset-view').remove();
    })

    /* Start : Navbar */
    $(function () {
        $('.navbar-toggler').click(function () {
            $('.navbar-toggler-icon').toggleClass('hidden');
            $('.mobile-search .search-icon').removeClass('hidden');
        });
        $('.close-icon').click(function () {
            $('.collapse').collapse('hide');
            $('.navbar-toggler-icon').toggleClass('hidden');

        });
        $('.mobile-search .search-icon').click(function () {
            $('.mobile-search .search-icon').toggleClass('hidden');
            $('.mobile-search .search-bar').toggleClass('show');
            if ($('.mobile-search .search-bar').hasClass('show')) {
                $('body').css('overflow-y', 'hidden')
            } else {
                $('body').css('overflow-y', 'auto')
            }
        });
    });

    $('.add-comment-popup .close-icon').on('click', function () {
        $('.overlay').removeClass('active');
    })

    $('.gta-nav-list .dropdown').hover(function () {
        $('.dropdown-toggle').removeClass('show').siblings('.dropdown-menu').removeClass('show')
        $(this).find('.dropdown-toggle').addClass('show').siblings('.dropdown-menu').addClass('show');
        $('.gta-nav-list .dropdown .dropdown-toggle').attr('aria-expanded', 'false');
        $(this).find('.dropdown-toggle').attr('aria-expanded', 'true');
    }).mouseleave(function () {
        $('.dropdown-toggle').removeClass('show').siblings('.dropdown-menu').removeClass('show');
        $('.dropdown-toggle').attr('aria-expanded', 'false');
    })

    // header mobile nav
    const menuBtn = document.querySelector('.gta-header .gta-nav-bar .menu-btn');
    const menuCloseBtn = document.querySelector('.gta-header .gta-mobile-nav .top .close-menu');
    const navDialog = document.querySelector('.gta-header .gta-mobile-nav');
    const bodyEle = document.querySelector('body');
    menuBtn.addEventListener('click', function() {
        navDialog.showModal();
        menuBtn.ariaExpanded = 'true'
        bodyEle.style.overflow = 'hidden';
    })
    menuCloseBtn.addEventListener('click', function() {
        navDialog.close();
        menuBtn.ariaExpanded = 'false'
        bodyEle.style.overflow = 'auto';
    })

    $('.gta-header .gta-nav-bar .search-btn').on('click', function () {
        $('.gta-nav-bar .menu-btn, .gta-nav-bar .gta-nav-logo, .gta-nav-bar .search-btn').fadeOut(10);
        $('.gta-nav-bar .mobile-search, .gta-nav-bar .close-search').fadeIn(10);
        $('.mobile-search .search-input input').focus();
    })
    $('.gta-header .gta-nav-bar .close-search').on('click', function () {
        $('.gta-nav-bar .menu-btn, .gta-nav-bar .gta-nav-logo, .gta-nav-bar .search-btn').fadeIn(10);
        $('.gta-nav-bar .mobile-search, .gta-nav-bar .close-search').fadeOut(10);
        $('.gta-header .gta-nav-bar .search-btn').focus()
    })
    // header mobile nav

    $('.go-up').on("click", function () {
        $('html, body').animate({ scrollTop: 0 }, 100);
        return false;
    });

    $('.search-pages-top .advanced-search .top-advanced-search .title').on('click', function () {
        $(this).parents('.advanced-search').toggleClass('show-advanced');
    })

    /// resize font
    var $affectedElements = $("p, h1, h2, h3, h4, h5, h6, a, button, div, li"); // Can be extended, ex. $("div, p, span.someClass")
    var increaseCount = 0
    var decreaseCount = 0
    // Storing the original size in a data attribute so size can be reset
    $affectedElements.each(function () {
        var $this = $(this);
        $this.data("orig-size", $this.css("font-size"));
    });

    $(".increase-font").click(function () {
        // console.log(increaseCount);
        if (increaseCount < 2) {
            changeFontSize(1);
            increaseCount++
            decreaseCount--
        }
    })

    $(".decrease-font").click(function () {
        // console.log(decreaseCount);
        if (decreaseCount < 2) {
            changeFontSize(-1);
            decreaseCount++
            increaseCount--
        }
    })

    $(".reset-font").click(function () {
        increaseCount = 0
        decreaseCount = 0
        $affectedElements.each(function () {
            var $this = $(this);
            $this.css("font-size", $this.data("orig-size"));
        });
    })

    function changeFontSize(direction) {
        $affectedElements.each(function () {
            var $this = $(this);
            $this.css("font-size", parseInt($this.css("font-size")) + direction);
        });
    }
    // resize font

    // start modal
    $(".job-details-apply .apply-btn, .job-details-view-col .apply-btn-at-end").on("click", function () {
        $(".overlay, .modal-apply-job").addClass("active");
    });
    $(".apply-job-title-and-btn .close-btn").on("click", function () {
        $(".overlay, .modal-apply-job").removeClass("active");
    });
    $('.job-details-view-col .apply-btn-at-end').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 500);
    })
    // end modal

    /* start accordion */
    // $(".about-us .accordion .accordion-item .accordion-header").on('click', function (event) {
    //     event.stopPropagation();
    //     event.stopImmediatePropagation();
    //     if ($(this).closest('.about-us .accordion-item').hasClass('active')) {

    //         $(".about-us .accordion-item").removeClass('active');
    //         $(this).closest('.about-us .accordion-item').removeClass('active');
    //     } else {
    //         $(".about-us .accordion-item").removeClass('active');
    //         $(".about-us .accordion-item .accordion-collapse").removeClass('show');
    //         $(".about-us .accordion-item .accordion-button").addClass('collapsed');
    //         $(this).closest('.about-us .accordion-item').addClass('active');
    //     }
    // });
    /* end accorion */

    // taxes-info accordion
    $('.taxes-info-body-screen .nav-tabs .nav-link').on('click', function () {
        $('.taxes-info-body-screen .nav-tabs .nav-link').removeClass('active');
        $(this).addClass('active');
    })
    // taxes-info accordion

    /* start media-center album view and list view */
    $('.media-center-body-screen .nav-item .nav-link').on('click', function () {
        $('.pics-album-btn').removeClass('active');
        $('.bottom-details-list').removeClass('album-view');
        $('.updates-btn').addClass('active');
    })
    $('.tab-sort-and-view button').on('click', function () {
        $('.tab-sort-and-view button').removeClass('active');
        $(this).toggleClass('active');
    })
    $('.pics-album-btn').on('click', function () {
        $('.bottom-details-list').addClass('album-view');
    })
    $('.updates-btn').on('click', function () {
        $('.bottom-details-list').removeClass('album-view');
    })
    /* end media-center album view and list view */

    /* start footer slicker carousel*/
    function footerSlickInit() {
        $('.related-links .slick').slick({
            draggable: true,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            speed: 300,
            rtl: dir === 'rtl' ? true : false,
            ltr: dir === 'ltr' ? true : false,
            variableWidth: true,
            prevArrow: dir === 'rtl' ? $('.right_btn') : $('.left_button'),
            nextArrow: dir === 'rtl' ? $('.left_button') : $('.right_btn'),
        });
    }
    var slickContent = $('.slick .related-links-img').length;
    var width = $(window).width();
    if (width > 992) {
        if (slickContent > 5) {
            footerSlickInit();
        } else {
            $('.cnct_btn').css('opacity', '0');
        }
    } else if (width < 992 && width > 768) {
        if (slickContent > 4) {
            footerSlickInit();
        } else {
            $('.cnct_btn').css('opacity', '0');
        }
    } else {
        footerSlickInit();
    }
    /* end footer slicker carousel*/

    /* start pagination active change */
    $('body').on('click', '.pagination-item', function () {
        $('.pagination-item').removeClass('active');
        $(this).addClass('active');
        $('html, body').animate({ scrollTop: 0 }, 300);
    })
    /* end pagination active change */

    // Date Piker
    if ($(".datePicker1").length > 0)
        $(".datePicker1").datepicker({
            startDate: new Date()
        })
    // End Date Piker

    // fancybox START
    if ($('.main-sub-news-details-content').length > 0 || $('.main-news-details-content').length > 0) {
        Fancybox.bind("[data-fancybox]");

        $('.big-img.slider').slick({
            infinite: false,
            autoplay: false,
            swipe: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: dir === 'rtl' ? true : false,
            asNavFor: '.small-imgs',
        })
        $('.small-imgs.slider').slick({
            infinite: false,
            autoplay: false,
            swipe: false,
            arrows: false,
            vertical: true,
            slidesToShow: $('.small-img').length,
            rtl: dir === 'rtl' ? true : false,
            asNavFor: '.big-img',
        })
        $('.imgs-collection .slick-slide').on('click', function() {
            const slideNo = $(this).data('slick-index');
            $('.small-imgs.slider').slick('slickGoTo', slideNo)
        })
    }
    // fancybox END

    // suggestion page
    // $(function () {
    //     $('.nav-item button').on('click', function () {
    //         var $this = $(this);
    //         $this.parent().addClass('active').siblings('li').removeClass('active')
    //     });
    // });
    //End suggestion page

    if ($(window).width() > 992) {
        $(document).on('scroll', function () {
            var y = $(this).scrollTop();
            var x = $('.gta-nav-bar').position();
            if (y > x.top + 100) {
                $('.gta-nav-bar').addClass('sticky');
            } else {
                $('.gta-nav-bar').removeClass('sticky');
            };
        });
    }

    // start footer stars
    // $(".review-bars .star").hover(function () {
    //     $(".review-bars .star").removeClass("active");
    //     $(this).addClass("active");
    //     $(this).prevAll().addClass("active");
    //     $(this).nextAll().removeClass("active");
    // });
    // $(".review-bars .star").mouseout(function () {
    //     $(".review-bars .star").removeClass("active");
    //     var parent = $('.review-bars .review-stars');
    //     var element = parent.children().get(selectedRate);
    //     var jQueryObject = $(element);
    //     jQueryObject.addClass("active");
    //     jQueryObject.prevAll().addClass("active");
    // });
    // $(".review-bars .star").click(function () {
    //     selectedRate = $(".review-bars .review-stars").children().index($(this));
    //     $(this).addClass("active");
    //     $(this).prevAll().addClass("active");
    //     $(this).nextAll().removeClass("active");
    //     $('.review-bars .star').parents().find('.review-bar-rate .add-comment-box').toggleClass('active');
    //     $('.review-bars .star').parents().find('.review-bar-rate .content').toggleClass('hidden');
    // });
    // end footer stars

    // footer call-bar
    // $('.call-numbers-bar .left').on('click', function () {
    //     $('.call-numbers-bar .left, .call-numbers-bar .right').addClass('hidden');
    //     $('.call-numbers-bar .full-subscribe-bar').addClass('active');
    // })
    // $('.call-numbers-bar .close-btn').on('click', function () {
    //     $('.call-numbers-bar .left, .call-numbers-bar .right').removeClass('hidden');
    //     $('.call-numbers-bar .full-subscribe-bar').removeClass('active');
    // })
    // footer call-bar

    // weather homepage
    $('.weather-report .weather-content .arrow-icon').on('click', function () {
        $('.weather-report').toggleClass('active');
        $('.weather-detailed').toggle();
    })
    // weather homepage

    // Footer add comment
    // $('.review-bars .add-comment').on('click', function () {
    //     $(this).parent().parent().parent().find('.add-comment-box').toggleClass('active');
    //     $(this).parent().parent().parent().find('.content').toggleClass('hidden');
    // })
    // $('.review-bars .question-answer .answer').on('click', function () {
    //     $(this).parent().parent().parent().parent().find('.add-comment-box').toggleClass('active');
    //     $(this).parent().parent().parent().parent().find('.content').toggleClass('hidden');
    // })
    // $('.add-comment-box .cancel-btn').on('click', function () {
    //     $(this).parent().toggleClass('active');
    //     $(this).parent().parent().find('.content').toggleClass('hidden');
    //     $('.review-section .review-stars-rate-and-comment').show();
    // })
    // Footer add comment

    // agreements map and list
    $('.agreements-body-screen #mapAndList .map-btn').on('click', function () {
        $('.agreements-body-screen .map-and-agreements-list-wrapper .left .zoom-controls').removeClass('hidden');
        $('.agreements-body-screen .map-and-agreements-list-wrapper .left .filtering').addClass('hidden');
    })
    $('.agreements-body-screen #mapAndList .list-btn').on('click', function () {
        $('.agreements-body-screen .map-and-agreements-list-wrapper .left .zoom-controls').addClass('hidden');
        $('.agreements-body-screen .map-and-agreements-list-wrapper .left .filtering').removeClass('hidden');
    })
    $('.agreements-body-screen #topics .accordion-item .accordion-body .nav-tabs .nav-item .nav-link').on('click', function () {
        $('.agreements-body-screen .map-and-agreements-list-wrapper').removeClass('active');
        $('.agreements-body-screen #topics .accordion-item .accordion-body .nav-tabs .nav-item .nav-link').removeClass('active').parent().removeClass('active');
        $('.agreements-body-screen #sources .accordion-item .accordion-body .nav-tabs .nav-item .nav-link').removeClass('active').parent().removeClass('active');
        $(this).addClass('active').parent().addClass('active');
    })
    $('.agreements-body-screen #sources .accordion-item .accordion-body .nav-tabs .nav-item .nav-link').on('click', function () {
        $('.agreements-body-screen .map-and-agreements-list-wrapper').addClass('active');
        $('.agreements-body-screen #sources .accordion-item .accordion-body .nav-tabs .nav-item .nav-link').removeClass('active').parent().removeClass('active');
        $('.agreements-body-screen #topics .accordion-item .accordion-body .nav-tabs .nav-item .nav-link').removeClass('active').parent().removeClass('active');
        $(this).addClass('active').parent().addClass('active');
    })
    if ($(window).width() < 992) {
        $('.agreements-body-screen .map-and-agreements-list-wrapper .top .left').prependTo('.agreements-body-screen #v-pills-tabContent');
        $('.agreements-body-screen .map-and-agreements-list-wrapper .top .left').remove();
    }
    // agreements map and list

    // agreement details page. move text on mobile
    if ($(window).width() < 992) {
        $('.agreements-details-body-screen .content-col .agreement-desc-wrapper').appendTo('.agreements-details-body-screen .agreement-desc-wrapper-media');
        $('.agreements-details-body-screen .content-col .agreement-desc-wrapper').remove();
    }
    // agreement details page. move text on mobile

    // video popup
    const videoDialog = document.querySelector('dialog.video-popup');
    $(document).on('click', '.video-box', function (e) {
        e.preventDefault();
        var videoLink = $(this).attr("data-video-src");
        $(".video video source").attr('src', videoLink);
        $('video')[0].load();
        $('video')[0].play();
        videoDialog.showModal();
    });
    $(document).on('click', '.video-popup .close-btn', function () {
        videoDialog.close();
        $('video')[0].pause();
    })
    // video popup

    // mobile input
    if ($('.phone-numbers').length) {
        $('.phone-numbers').intlTelInput({
            initialCountry: "qa",
            utilsScript: "/assets/src/vendors/js/utils.js",
            autoPlaceholder: "aggressive",
            customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                if (selectedCountryData.iso2 === 'qa') {
                    return "3312 3456";
                } else {
                    return selectedCountryPlaceholder
                }
            },
            // separateDialCode: true,
        })
    }
    // mobile input

    // faq scroll on category click
    $('.faq-body-screen .navigate-items .nav-tabs .nav-item .nav-link').on('click', function () {
        if ($(window).width() < 992) {
            $('html, body').animate({
                scrollTop: $(".accordion-items-field .tab-content").offset().top
            }, 200);
        }
    })

    // focus on content when opened
    $(document).on('click', '.faq-body-screen .tab-pane .accordion-button', function() {
        const accBody = $(this).attr('data-bs-target');
        $('.faq-body-screen .tab-pane ' + accBody).find('.accordion-body').attr('tabindex', -1).focus();
    })
    // faq scroll on category click


    // tabs url-based change and on click
    if ($('.aboutus-body-screen').length > 0) {
        var url = window.location.href;
        var activeTab = url.substring(url.indexOf("#") + 1);
        // console.log(activeTab);
        $('#v-pills-tab button[tax-url="' + activeTab + '"]').tab('show');
        // let accordionTab = '#' + $('.about-us .accordion .ac-body .nav-link[tax-url="' + activeTab + '"]').attr('tax-url');
        // if (window.location.hash == accordionTab) {
        //     $(".about-us .accordion .accordion-item .accordion-button").click();
        //     $('.about-us .accordion-button').css({
        //         'background-color': '#8e1537',
        //         "color": 'white',
        //         "border-radius": '10px 10px 0px 0px',
        //         "border-bottom": '0'
        //     })
        //     $('.accordion-item').removeClass('unselected');
        //     $('#v-pills-tab button[tax-url="' + activeTab + '"]').tab('show');
        // }

        $('.nav-link').on('click', function () {
            var tabId = $(this).attr('data-bs-target');
            var tabpane = $(tabId)
            tabpane.find("h2").attr('tabindex', -1).focus();
        })
        // $('.accordion .accordion-button').on('click', function () {
        //     $('.accordion .ac-body .nav-link').removeClass('active');
        //     $(this).parent().siblings().find('.ac-body').first().find('.nav-link').tab('show');
        // })
        $('.box-gold').css('background-color', '#f2f2f2');

        $('.gta-nav-list ul li a').on('click', function () {
            var url = $(this).attr('href');
            var activeTab = url.substring(url.indexOf("#") + 1);
            $('#v-pills-tab button[tax-url="' + activeTab + '"]').tab('show');
            let accordionTab = '#' + $('.about-us .accordion .ac-body .nav-link[tax-url="' + activeTab + '"]').attr('tax-url');
            if (window.location.hash == accordionTab) {
                $(".about-us .accordion .accordion-item .accordion-button").click();
                $('.about-us .accordion-button').css({
                    'background-color': '#8e1537',
                    "color": 'white',
                    "border-radius": '10px 10px 0px 0px',
                    "border-bottom": '0'
                })
                $('.accordion-item').removeClass('unselected');
                $('#v-pills-tab button[tax-url="' + activeTab + '"]').tab('show');
            }
        })
        $('.mobile-nav-list ul li a').on('click', function () {
            var url = $(this).attr('href');
            var activeTab = url.substring(url.indexOf("#") + 1);
            $('#v-pills-tab button[tax-url="' + activeTab + '"]').tab('show');
            let accordionTab = '#' + $('.about-us .accordion .ac-body .nav-link[tax-url="' + activeTab + '"]').attr('tax-url');
            if (window.location.hash == accordionTab) {
                $(".about-us .accordion .accordion-item .accordion-button").click();
                $('.about-us .accordion-button').css({
                    'background-color': '#8e1537',
                    "color": 'white',
                    "border-radius": '10px 10px 0px 0px',
                    "border-bottom": '0'
                })
                $('.accordion-item').removeClass('unselected');
                $('#v-pills-tab button[tax-url="' + activeTab + '"]').tab('show');
            }
            $('.gta-header .gta-mobile-nav').fadeOut(200);
            $('.overlay').fadeOut(200);
        })
    }

    if ($('.taxes-info-body-screen').length > 0) {
        $('.navigate-items .nav-link.single').removeClass('active');
        // $('.accordion-button').addClass('collapsed').removeClass('collapse show');
        // $('.accordion-collapse').removeClass('show');
        var url = window.location.href;
        var activeTab = url.substring(url.indexOf("#") + 1);

        $('.accordion .accordion-button').on('click', function () {
            $('.nav-link').removeClass('active');
            if ($(this).hasClass('collapsed')) {
                // console.log('has');
                $(this).addClass('collapsed');
                $('.accordion .accordion-button').addClass('collapsed');
            } else {
                // console.log('has not');
                $('.accordion .accordion-button').addClass('collapsed');
                $(this).removeClass('collapsed');
            }
            $('.tab-pane').removeClass('active show');
            $(this).parent().siblings().find('.nav-tabs .nav-item').first().find('.nav-link').tab('show');
            var tabId = $(this).parent().siblings().find('.nav-tabs .nav-item').first().find('.nav-link').attr('data-bs-target');
            var tabpane = $(tabId)
            tabpane.children("h3").attr('tabindex', -1).focus();
        })

        $('.nav-common-tabs .nav-link').on('click', function () {
            if($(this).hasClass('single') && $('.accordion-collapse').hasClass('show')) {
                $('.accordion .accordion-button').addClass('collapsed');
                $('.accordion-collapse').removeClass('show');
            }

            var tabId = $(this).attr('data-bs-target');
            var tabpane = $(tabId)
            tabpane.children("h3").attr('tabindex', -1).focus();
        })

        // $('.nav-link').on('click', function() {
        //     var tabId = $(this).attr('data-bs-target');
        //     var tabpane = $(tabId)
        //     tabpane.children("h3").focus();
        // })

        if ($('.nav-link[tax-url="' + activeTab + '"]').parent().hasClass('nav-item')) { // if the link clicked is for accordion
            $('.nav-link[tax-url="' + activeTab + '"]').parent().parent().parent().parent().parent().find('.accordion-button').click();
        } else {
            $('.nav-link[tax-url="' + activeTab + '"]').tab('show');
        }
        // $('.tab-pane').removeClass('active show');

        if (window.location.hash === '') {
            // console.log($('.nav-common-tabs .accordion>*:first-child'));
            if ($('.nav-common-tabs .accordion>*:first-child').hasClass('accordion-item')) {
                $('.accordion .accordion-item:first-child').find('.accordion-button').click()
                    .parent().siblings().find('.nav-tabs .nav-item').first().find('.nav-link').tab('show');
            } else {
                $('.nav-link.single:first-child').tab('show');
            }
        }

        $('.gta-nav-list ul li a').on('click', function () {
            var url = $(this).attr('href');
            var activeTabA = url.substring(url.indexOf("#") + 1);
            if ($('.nav-link[tax-url="' + activeTabA + '"]').parent().hasClass('nav-item')) {
                $('.nav-link[tax-url="' + activeTabA + '"]').parent().parent().parent().parent().parent().find('.accordion-button').click();
            }
            $('.tab-pane[aria-labelledby="' + activeTabA + '"]').addClass('active show');
            $('.nav-link[tax-url="' + activeTabA + '"]').tab('show');
            $('.nav-link[tax-url="' + activeTabA + '"]').click();
        })
        $('.mobile-nav-list ul li a').on('click', function () {
            var url = $(this).attr('href');
            var activeTab = url.substring(url.indexOf("#") + 1);
            if ($('.nav-link[tax-url="' + activeTab + '"]').parent().hasClass('nav-item')) {
                $('.nav-link[tax-url="' + activeTab + '"]').parent().parent().parent().parent().parent().find('.accordion-button').click();
                menuCloseBtn.click();
                return
            }
            $('.navigate-items .nav-link').removeClass('active');
            $('.tab-pane[aria-labelledby="' + activeTab + '"]').addClass('active show');
            $('.navigate-items .accordion .accordion-button').addClass('collapsed');
            $('.navigate-items .accordion .accordion-collapse').removeClass('show');
            $('.navigate-items .nav-link[tax-url="' + activeTab + '"]').tab('show');
            $('.navigate-items .nav-link[tax-url="' + activeTab + '"]').click();
            menuCloseBtn.click();
        })
    }

    if ($('.laws-body-screen').length > 0) {
        $('.nav-common .nav-link').on('click', function () {
            var tabId = $(this).attr('data-bs-target');
            var tabpane = $(tabId)
            tabpane.find("h2").attr('tabindex', -1).focus();
        })
    }

    if ($('.media-center-body-screen').length > 0) {
        $('.words-list .words-item, .years .year-item, .navigate-items .nav-item').on('click', function () {
            if ($(window).width() < 992) {
                $('html, body').animate({ scrollTop: 0 }, 200);
            }
        })
    }
    // tabs url-based change and on click

    // statistics counter
    // !(function (e, t) {
    //     "object" == typeof exports && "object" == typeof module
    //         ? (module.exports = t())
    //         : "function" == typeof define && define.amd
    //             ? define([], t)
    //             : "object" == typeof exports
    //                 ? (exports.counterUp = t())
    //                 : (e.counterUp = t());
    // })(self, function () {
    //     return (() => {
    //         "use strict";
    //         var e = {
    //             d: (t, n) => {
    //                 for (var o in n)
    //                     e.o(n, o) &&
    //                         !e.o(t, o) &&
    //                         Object.defineProperty(t, o, { enumerable: !0, get: n[o] });
    //             },
    //             o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
    //             r: (e) => {
    //                 "undefined" != typeof Symbol &&
    //                     Symbol.toStringTag &&
    //                     Object.defineProperty(e, Symbol.toStringTag, {
    //                         value: "Module",
    //                     }),
    //                     Object.defineProperty(e, "__esModule", { value: !0 });
    //             },
    //         },
    //             t = {};
    //         e.r(t), e.d(t, { default: () => n, divideNumbers: () => r });
    //         const n = (e, t = {}) => {
    //             const {
    //                 action: n = "start",
    //                 duration: i = 1e3,
    //                 delay: u = 16,
    //             } = t;
    //             if ("stop" === n) return void o(e);
    //             if ((o(e), !/[0-9]/.test(e.innerHTML))) return;
    //             const l = r(e.innerHTML, {
    //                 duration: i || e.getAttribute("data-duration"),
    //                 delay: u || e.getAttribute("data-delay"),
    //             });
    //             (e._countUpOrigInnerHTML = e.innerHTML),
    //                 (e.innerHTML = l[0] || "&nbsp;"),
    //                 (e.style.visibility = "visible");
    //             const c = function () {
    //                 (e.innerHTML = l.shift() || "&nbsp;"),
    //                     l.length
    //                         ? (clearTimeout(e.countUpTimeout),
    //                             (e.countUpTimeout = setTimeout(c, u)))
    //                         : (e._countUpOrigInnerHTML = void 0);
    //             };
    //             e.countUpTimeout = setTimeout(c, u);
    //         },
    //             o = (e) => {
    //                 clearTimeout(e.countUpTimeout),
    //                     e._countUpOrigInnerHTML &&
    //                     ((e.innerHTML = e._countUpOrigInnerHTML),
    //                         (e._countUpOrigInnerHTML = void 0)),
    //                     (e.style.visibility = "");
    //             },
    //             r = (e, t = {}) => {
    //                 const { duration: n = 1e3, delay: o = 16 } = t,
    //                     r = n / o,
    //                     i = e.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
    //                     u = [];
    //                 for (let e = 0; e < r; e++) u.push("");
    //                 for (let e = 0; e < i.length; e++)
    //                     if (
    //                         /([0-9.][,.0-9]*[0-9]*)/.test(i[e]) &&
    //                         !/<[^>]+>/.test(i[e])
    //                     ) {
    //                         let t = i[e];
    //                         const n = [...t.matchAll(/[.,]/g)]
    //                             .map((e) => ({ char: e[0], i: t.length - e.index - 1 }))
    //                             .sort((e, t) => e.i - t.i);
    //                         t = t.replace(/[.,]/g, "");
    //                         let o = u.length - 1;
    //                         for (let e = r; e >= 1; e--) {
    //                             let i = parseInt((t / r) * e, 10);
    //                             (i = n.reduce(
    //                                 (e, { char: t, i: n }) =>
    //                                     e.length <= n ? e : e.slice(0, -n) + t + e.slice(-n),
    //                                 i.toString()
    //                             )),
    //                                 (u[o--] += i);
    //                         }
    //                     } else for (let t = 0; t < r; t++) u[t] += i[e];
    //                 return (u[u.length] = e.toString()), u;
    //             };
    //         return t;
    //     })();
    // });
    // $(function () {
    //     /* START :: Counter Up */
    //     if ($(".counter, .number-counter").length) {
    //         const counterUp = window.counterUp.default;
    //         const callback = (entries) => {
    //             entries.forEach((entry) => {
    //                 const el = entry.target;
    //                 if (
    //                     entry.isIntersecting &&
    //                     !el.classList.contains("is-visible")
    //                 ) {
    //                     counterUp(el, {
    //                         duration: 1000,
    //                         delay: 16,
    //                     });
    //                     el.classList.add("is-visible");
    //                 }
    //             });
    //         };
    //         const IO = new IntersectionObserver(callback, { threshold: 1 });
    //         $(".counter, .number-counter").each(function () {
    //             IO.observe(this);
    //         });
    //     }
    //     /* END :: Counter Up */
    // });
    // statistics counter

    if ($(window).width() > 991 && $('dialog.app-dialog').length > 0) {
        const appDialog = document.querySelector('dialog.app-dialog');
        const dialogCloseBtn = document.querySelector('.app-dialog .close-btn');
        $('.apps-icons .app-link').on('click', function(e) {
            e.preventDefault();
            var appTitle = $(this).find('.app-text').text().trim();
            var appImg = $(this).find('.app-icon img').attr('src');
            
            var gLink = $(this).data('g_url');
            var aLink = $(this).data('a_url');

            $('.store-link.app_store').attr('href', aLink);
            $('.store-link.google_play').attr('href', gLink);
            $('.app-dialog .app-icon img').attr('src', appImg);
            $('.app-dialog .app-icon img').attr('alt', appTitle);
            $('.app-dialog h4').text(appTitle);
            appDialog.showModal();
            appDialog.ariaHidden = 'false';
        })

        dialogCloseBtn.addEventListener('click', function() {
            appDialog.close();
            appDialog.ariaHidden = 'true';
        })
    } else {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // console.log(userAgent);
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            $('.apps-icons .app-link').each(function() {
                var gLink = $(this).data('g_url');
                $(this).attr('href', gLink);
            })
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            $('.apps-icons .app-link').each(function() {
                var gLink = $(this).data('g_url');
                $(this).attr('href', gLink);
            })
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
            $('.apps-icons .app-link').each(function() {
                var gLink = $(this).data('a_url');
                $(this).attr('href', gLink);
            })
            return "iOS";
        }

        return "unknown";
    }
});